import { Typography } from '@mui/material';

const Title = ({ title, sx }) => {
  return (
    <Typography
      component="h1"
      sx={{
        flexGrow: 1,
        fontSize: '1.75rem',
        ...sx,
      }}
    >
      {title}
    </Typography>
  );
};

export default Title;
